module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<h5>Rates</h5> <div class=\"table-wrap\"> <table class=\"table table-hover payment-logs-table\"> <thead> <tr> <th>Carrier</th> <th>Service</th> <th>Rate</th> </tr> </thead> <tbody> ")
    ;  if(locals.rates.length == 0) { 
    ; __append(" <tr> <td colspan=\"3\" class=\"no_results\"> No rates are available to view. </td> </tr> ")
    ;  } else { 
    ; __append(" ")
    ;  _.each(locals.rates, function(rate) { 
    ; __append(" <tr id=\"rate_")
    ; __append(escapeFn( rate.id ))
    ; __append("\"></tr> ")
    ;  }); 
    ; __append(" ")
    ;  } 
    ; __append(" </tbody> </table> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/rate_list.ejs
// module id = 863
// module chunks = 1